<div class="busy-indicator-circular">
  <svg xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 20 20"
      class="busy-indicator-circular-container"
      style="width: 20px; height: 20px; transform-origin: 10px 10px 10px;">
      <path fill="none" 
            stroke-width="2" 
            class="busy-indicator-circular-path"
            stroke-linecap="square" 
            d="M10,1A9,9 0 1 1 1,10"
            transform="rotate(-270 10 10)"></path>
  </svg>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/busy-indicator/busy-indicator-circular/busy-indicator-circular.html